import { WindowHelper } from '../WindowHelper';
import DesktopActiveStateHandler from './desktop-active-state-handler';

export default class ProjectFilter extends DesktopActiveStateHandler {
    attachEvents() {
        if (WindowHelper.isTouchDevice()) {
            console.log('seems touchdevice');
            super.activateProjectFromSelectedItem();
        } else {
            console.log('seems not touchdevice');
            super.eventActivateSelected();
        }
    }

    constructor(filterContainerNodeQS) {
        super(filterContainerNodeQS);

        if (WindowHelper.isElementThere(filterContainerNodeQS)) {
            this.attachEvents();
        }
    }
}
